import Component from '@glimmer/component';
import ProjectsAbstractStatusComponent from 'seshy/components/projects/abstract/status';

export default class ProjectsIconComponent extends ProjectsAbstractStatusComponent {}
